import { CommonModule, NgOptimizedImage } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  effect,
  inject,
  signal,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { RouterLink } from '@angular/router';
import { AvailableDateModel, RoomModel } from '@models/room';
import { CountDownComponent } from '@shared/components/countDown/count-down.component';
import { CounterComponent } from '@shared/components/counter/counter.component';
import { DatepickerComponent } from '@shared/components/datepicker/datepicker.component';
import { DatepickerDirective } from '@shared/directives/datepicker.directive';
import { RialToTomanPipe } from '@shared/pipes/rial-to-toman.pipe';
import { DatepickerService } from '@shared/services/datepicker.service';
import { LoadingService } from '@shared/services/loading.service';
import { HotelInfoUiService } from '../../services/hotel-info-ui.service';
import { GalleryRoomsModalComponent } from '../gallery-rooms-modal/gallery-rooms-modal.component';
import { ModalService } from '@shared/services/modal.service';
import { DateOfStayModalComponent } from '../date-of-stay-modal/date-of-stay-modal.component';
import { cdnUrl } from 'apps/ihowebsite/src/app/app.module';
import { PdpRoomlimitsModalComponent } from '../pdp-roomlimits-modal/pdp-roomlimits-modal.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SearchBoxService } from '@shared/services/serach-box.service';
@Component({
  selector: 'iho-pdp-rooms-cards',
  standalone: true,
  templateUrl: './pdp-rooms-cards.component.html',
  styleUrls: ['./pdp-rooms-cards.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    MatButtonModule,
    CounterComponent,
    RialToTomanPipe,
    CountDownComponent,
    NgOptimizedImage,
    DatepickerComponent,
    DatepickerDirective,
    RouterLink,
  ],
})
export class PdpRoomsCardsComponent implements OnInit {
  pdpUiService = inject(HotelInfoUiService);
  dialog = inject(MatDialog);
  loadingService = inject(LoadingService);
  datepickerService = inject(DatepickerService);
  searchBoxService = inject(SearchBoxService);

  @Input() roomId = 0;
  @Input() dataSource!: RoomModel & { secondId?: number; secondName?: string; secondImage?: string };
  @Input() breakFastType: any;
  @Input() limitCountNightRange!: any;
  @Input() limitCountNights = 0;
  @Input() packages: any;
  @Input() hotelIsFull = false;
  @Input() isCombo = false;
  @Input() isMobile = false;
  @Input() comboRoomName?: string;
  @Input() secondComboRoomImage?: string;

  disableComboBtn = false;
  @Output() availableDatesClicked = new EventEmitter<AvailableDateModel[]>();
  @Output() addComboRooms = new EventEmitter<string>();
  @Output() removeComboRooms = new EventEmitter<string>(); // we dont use it anymore

  outOfPackagePeriod = -1;
  packageRoomId = -1;
  resetCount = false;
  isHourlyMessage = '';
  isToggle: boolean = false;
  nightsToStand = 0;
  cdnUrl = cdnUrl;
  InNightLimitRange = signal(false);
  limitFrom = signal(0);
  limitTo = signal(0);
  newPackages: any = [];
  constructor() {
    this.nightsToStand = this.pdpUiService.nights;
    this.limitFrom.set(this.pdpUiService.roomApiResponse$.value.limitCountNightRange?.limitFrom);
    this.limitTo.set(this.pdpUiService.roomApiResponse$.value.limitCountNightRange?.limitTo);
    if (this.nightsToStand > this.limitFrom() && this.nightsToStand < this.limitTo()) {
      this.InNightLimitRange.set(true);
    }

    effect(() => {
      if (this.pdpUiService.selectedComboRooms().length) {
        this.disableComboBtn = true;
      } else this.disableComboBtn = false;
    });
  }

  ngOnInit(): void {
    this.handledPackages();
    // this.handledPackagesNew();
  }
  handledPackagesNew() {
    // بررسی اینکه پکیج‌ها وجود دارند
    if (this.packages && this.packages?.pakages?.length) {
      const [syear, smonth, sday] = this.datepickerService._startDate().split('/');
      const [eyear, emonth, eday] = this.datepickerService._endDate().split('/');
      let startDate = `${syear}/${('0' + smonth).slice(-2)}/${('0' + sday).slice(-2)}`;
      let endDate = `${eyear}/${('0' + emonth).slice(-2)}/${('0' + eday).slice(-2)}`;

      // حذف داده‌های تکراری با استفاده از Map
      let uniquePackages = new Map();
      this.packages.pakages.forEach((pack: any) => {
        if (pack.roomIds && pack.roomIds.length) {
          pack.roomIds.forEach((roomId: number) => {
            let newPack = { ...pack, roomId };
            if (!uniquePackages.has(newPack.id + '-' + roomId)) {
              uniquePackages.set(newPack.id + '-' + roomId, newPack);
            }
          });
        } else {
          if (!uniquePackages.has(pack.id)) {
            uniquePackages.set(pack.id, pack);
          }
        }
      });

      let filteredPackages = Array.from(uniquePackages.values()).filter(
        (item: any) =>
          (startDate >= item.startDatePersian && startDate <= item.endDatePersian) ||
          (endDate >= item.startDatePersian && endDate <= item.endDatePersian)
      );

      if (filteredPackages.length > 0) {
        this.outOfPackagePeriod = 0;
      } else {
        this.outOfPackagePeriod = -1;
      }
    }
  }
  handledPackages() {

    // outOfPackagePeriod 0 is showModal and -1 nothing new branch
    if (this.packages && this.packages?.pakages?.length) {
      const [syear, smonth, sday] = this.datepickerService._startDate().split('/');
      const [eyear, emonth, eday] = this.datepickerService._endDate().split('/');
      let startDate = `${syear}/${('0' + smonth).slice(-2)}/${('0' + sday).slice(-2)}`;
      let endDate = `${eyear}/${('0' + emonth).slice(-2)}/${('0' + eday).slice(-2)}`;
      // new logic
      let findAll = this.packages.pakages.map((item: any) => ({
        id: item.id,
        startDate: item.startDate,
        endDate: item.endDate,
        startDatePersian: item.startDatePersian,
        endDatePersian: item.endDatePersian,
        night: item.night,
        url: item.url,
        roomId: item.allRooms ? 0 : item.roomId,
        allRooms: item.allRooms,
        roomIds: item.allRooms ? this.packages.pakages[0].roomIds : [],
      }));

      let newarr = findAll.flatMap((item: any) => {
        if (item.allRooms) {
          return item.roomIds.map((ids: any) => ({
            id: item.id,
            startDate: item.startDate,
            endDate: item.endDate,
            startDatePersian: item.startDatePersian,
            endDatePersian: item.endDatePersian,
            night: item.night,
            url: item.url,
            roomId: ids,
            allRooms: true,
          }));
        } else {
          return item;
        }
      });


      this.newPackages = newarr;


      let packageFilter = newarr.filter((item: any) => item.roomId == this.roomId);
      const departingPacks = packageFilter.find((pack: any) => {
        let cond = startDate > pack.startDatePersian && startDate < pack.endDatePersian;
        return cond;
      });

      const returningPacks = packageFilter.find(
        (pack: any) => endDate > pack.startDatePersian && endDate < pack.endDatePersian
      );

      if (!returningPacks && !departingPacks) {
        this.outOfPackagePeriod = -1;
      } else {
        const departingPacksB = packageFilter.filter((pack: any) => {
          const condition = startDate == pack.startDatePersian || startDate == pack.endDatePersian;
          pack.acceptedCondition =
            !pack.acceptedCondition && startDate == pack.startDatePersian ? 1 : pack.acceptedCondition;
          pack.acceptedCondition =
            !pack.acceptedCondition && startDate == pack.endDatePersian ? 2 : pack.acceptedCondition;
          return condition;
        });
        const returningPacksB = packageFilter.filter((pack: any) => {
          const condition = endDate == pack.startDatePersian || endDate == pack.endDatePersian;
          pack.acceptedCondition =
            !pack.acceptedCondition && endDate == pack.startDatePersian ? 1 : pack.acceptedCondition;
          pack.acceptedCondition =
            !pack.acceptedCondition && endDate == pack.endDatePersian ? 2 : pack.acceptedCondition;
          return condition;
        });
        if (
          (!departingPacks || departingPacksB?.length) &&
          (!returningPacks || returningPacksB?.length)
        ) {
          const allDepartingEqualDeparting = departingPacksB.every((x: any) => x.acceptedCondition == 1);
          const allDepartingEqualReturning = departingPacksB.every((x: any) => x.acceptedCondition == 2);
          // ---
          const allReturningEqualDeparting = returningPacksB.every((x: any) => x.acceptedCondition == 1);
          const allReturningEqualReturning = returningPacksB.every((x: any) => x.acceptedCondition == 2);

          if (
            departingPacksB?.length === returningPacksB?.length &&
            ((allDepartingEqualDeparting && allReturningEqualDeparting) ||
              (allDepartingEqualReturning && allReturningEqualReturning))
          ) {
            if (!this.dataSource.isHourly) {
              this.outOfPackagePeriod = 0;
            }
          } else {
            this.outOfPackagePeriod = -1;
          }
        } else {
          if (!this.dataSource.isHourly) this.outOfPackagePeriod = 0;
        }
      }
    }
  }

  shwoModalPackages(ev: Event, roomId: number, outOfPackagePeriod: number) {
    ev.preventDefault();
    const dialogRef = this.dialog.open(DateOfStayModalComponent, {
      panelClass: [
        'packages-modal-rooms',
        'w-screen',
        'lg:w-[45%]',
        'h-screen',
        '!max-w-full',
        'lg:h-[50vh]',
        'lg:min-h-[600px]',
        'custom-modal',
      ],
      data: {
        package: this.newPackages,
        roomId: roomId,
        outOfPackagePeriod: outOfPackagePeriod,
      },
      autoFocus: false,
    });
  }

  showLimitsModal(roomInfo: any) {
    if (
      !(
        (this.InNightLimitRange() && !this.dataSource.isHourly) ||
        (roomInfo.roomAvailableDate.checkInLimit && !roomInfo.roomAvailableDate.checkOutLimit) ||
        (roomInfo.roomAvailableDate.checkOutLimit && !roomInfo.roomAvailableDate.checkInLimit) ||
        (roomInfo.roomAvailableDate.checkOutLimit && roomInfo.roomAvailableDate.checkInLimit) ||
        (this.dataSource.isHourly && this.nightsToStand > 1)
      )
    ) {
      return;
    }

    const dialogRef = this.dialog.open(PdpRoomlimitsModalComponent, {
      panelClass: [
        'packages-modal-rooms',
        'w-screen',
        'lg:w-[398px]',
        'h-screen',
        '!max-w-full',
        'lg:h-auto',
        'lg:min-h-[190px]',
        'custom-modal',
      ],
      data: {
        roomInfo: roomInfo,
        isHourly: this.dataSource.isHourly,
        nightsToStand: this.nightsToStand,
        limitFrom: this.limitFrom(),
        limitTo: this.limitTo(),
        isInLimitRange: this.InNightLimitRange(),
      },
      autoFocus: false,
    });
  }

  increaseRoomCount(nonRefundable: any, isCombo = false) {
    if (this.dataSource.isHourly && this.dataSource.roomInfos[0].roomPrice.price.nights > 1) {
      this.isHourlyMessage = 'رزرو اتاق ساعتی برای بیش از یک شب مجاز نمیباشد';
      return;
    }

    this.pdpUiService.increaseSelectedRooms(
      this.dataSource.roomInfos.filter((item) => item.roomDetail.nonRefundable == nonRefundable)[0],
      this.dataSource.id,
      this.dataSource.name,
      isCombo
    );
  }

  decreaseRoomCount(nonRefundable: any, isCombo = false) {
    this.pdpUiService.decreaseSelectedRooms(this.dataSource.id, this.dataSource.name, isCombo);
  }

  toggleComboSelection(comboId: string) {
    // if(this.pdpUiService.selectedComboRooms()?.length) {
    //   this.pdpUiService.removeComboRoomsSelection(comboId)
    //   this.disableComboBtn = false
    // }
    // else
    this.pdpUiService.addComboRoomsToSelection(comboId);
    this.disableComboBtn = true;
  }

  modalService = inject(ModalService);
  destroyRef = inject(DestroyRef);

  showModalRooms(roomId: number, roomInfo: any) {
    this.loadingService.isInterceptorActive.set(true);
    const dialogRef = this.dialog.open(GalleryRoomsModalComponent, {
      panelClass: [
        'gallery-modal-rooms',
        'w-screen',
        'lg:w-[60%]',
        'h-screen',
        '!max-w-full',
        'lg:h-[66vh]',
        'lg:min-h-[600px]',
        'custom-modal',
      ],
      data: {
        roomId: roomId,
        roomInfo: roomInfo,
        hotelId: this.pdpUiService.hotelId,
        isHourly: this.dataSource.isHourly,
        breakFastType: this.breakFastType,
      },
      autoFocus: false,
    });
    dialogRef
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((result) => {
        this.modalService.isAnyModalOpen.set(false);
      });

    dialogRef
      .afterOpened()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.modalService.isAnyModalOpen.set(true);
      });
  }

  emitAvailableDates(eventData: AvailableDateModel[]) {
    this.availableDatesClicked.emit(eventData);
  }

  navigateToFollowReservation(nonRefundable: boolean, roomInfo: any) {
    if (
      roomInfo.roomAvailableDate.checkInLimit ||
      roomInfo.roomAvailableDate.checkOutLimit ||
      (this.InNightLimitRange() && !this.dataSource.isHourly) ||
      (this.dataSource.isHourly && this.nightsToStand > 1)
    ) {
      this.showLimitsModal(roomInfo);
      return;
    }
    // const link =
    //  '/persian/pursuit' +
    //  ('?hotelId=' + this.pdpUiService.hotelId) +
    //  ('&dateLength=' + this.nightsToStand) +
    //  ('&departing=' + this.datepickerService._startDate()) +
    //  ('&returning=' + this.datepickerService._endDate()) +
    //  ('&iswaitinglist=true&selectedRooms=' +
    //   JSON.stringify([{ id: this.dataSource.id, count: 1, nonRefundable }]));

    // location.href = location.origin + link;

    const _payload = {
      hotelId: this.pdpUiService.hotelId,
      arrivalDate: this.datepickerService._startDate(),
      checkoutDate: this.datepickerService._endDate(),
      rooms: [
        {
          id: this.dataSource.id,
          quantity: 1,
          nonRefundablem: this.dataSource.roomInfos[0].roomDetail.nonRefundable,
          index: 0,
        },
      ],
      IsWaitingList: true,
      organizationId: null,
      comboRooms: this.pdpUiService.selectedComboRooms().length
        ? this.pdpUiService.selectedComboRooms()[0].combenationId
        : null,
      AccommodationType: this.searchBoxService.accommodation() == 'ecolodge' ? 2 : 1,
    };

    this.pdpUiService.getReserveUUID(_payload).subscribe((uuid) => {
      if (uuid) {
        window.location.href = window.location.origin + '/persian/pursuit/resid/' + uuid;
      }
    });
  }
}
